import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';

// Connects to data-controller="buy-number"
export default class extends Controller {
  static targets = ['countrySelect', 'countryCodeDisplay', 'number', 'spinner'];

  connect() {
    const selectedOption = this.countrySelectTarget.options[this.countrySelectTarget.selectedIndex]
    const display = selectedOption.dataset.display
    this.countryCodeDisplayTarget.textContent = display

    this.fetchAvailableNumbers()
  }

  changeCountry(e) {
    e.preventDefault()
    const selectedOption = e.target.options[e.target.selectedIndex]
    const display = selectedOption.dataset.display
    this.countryCodeDisplayTarget.textContent = display

    this.fetchAvailableNumbers()
  }

  async fetchAvailableNumbers(e) {
    if (e) {
      e.preventDefault()
    }

    if (this.spinnerTarget.classList.contains('hidden')) {
      this.spinnerTarget.classList.remove('hidden')
    }

    const response = await get('/buy_numbers', {
      query: {
        country_code: this.countrySelectTarget.value,
        search: this.numberTarget.value,
        mode: this.element.dataset.mode
      },
      responseKind: "turbo-stream"
    })

    if (response.ok) {
      this.spinnerTarget.classList.add('hidden')
    } else {
      this.spinnerTarget.classList.add('hidden')
    }
  }
}
